<sm-dialog-template header="MARKDOWN CHEAT SHEET" [iconClass]="'al-ico-markdown'" tabindex="0">
  <div [innerHTML]="mdCheatSheetHtmlFile"></div>
</sm-dialog-template>
